var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useController, useForm } from 'react-hook-form';
import { useLanguage } from '../../locale';
import { useEffect, useMemo, useRef } from 'react';
import { useGetPersonApi } from '../../hooks';
import { useGetCustomerApi } from '../../hooks';
import { useFamilyMemberComposer } from './useFamilyMemberComposer.facade';
import { GeneralActions, isFamilyMemberRegisterRequested } from '../../redux';
import { useDispatch, useSelector } from 'react-redux';
import { useUpdateProfileHelper } from './helpers/useUpdateProfileHelper';
import { nameValidation } from '../../utils/regex';
export var useInputNameFormFacade = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var onNext = _a.onNext, personId = _a.personId, _h = _a.isFamilyMemberUpdate, isFamilyMemberUpdate = _h === void 0 ? false : _h;
    var t = useLanguage()[0];
    var dispatch = useDispatch();
    //** REDUX **//
    var isNewFamilyMember = useSelector(isFamilyMemberRegisterRequested);
    var isFamilyMember = isNewFamilyMember || isFamilyMemberUpdate;
    //** API **//
    var customer = useGetCustomerApi(!isFamilyMember).data;
    var person = useGetPersonApi(personId || (customer === null || customer === void 0 ? void 0 : customer.personId)).data;
    var profile = useFamilyMemberComposer().profile;
    var isB2BUser = ((_b = customer === null || customer === void 0 ? void 0 : customer.Subscription) === null || _b === void 0 ? void 0 : _b.channel) === 'B2B_CODE';
    var updateProfile = useUpdateProfileHelper({
        isFamilyMember: isNewFamilyMember,
        person: person,
        customer: customer,
    }).updateProfile;
    //** FORM **//
    var _j = useForm({
        mode: 'onChange',
    }), control = _j.control, handleSubmit = _j.handleSubmit, setValue = _j.setValue;
    useEffect(function () {
        var _a, _b, _c;
        if (isNewFamilyMember) {
            setValue('name', (_a = profile === null || profile === void 0 ? void 0 : profile.name) !== null && _a !== void 0 ? _a : '');
            setValue('surname', (_b = profile === null || profile === void 0 ? void 0 : profile.surname) !== null && _b !== void 0 ? _b : '');
            return;
        }
        if (person) {
            setValue('name', person.name);
            setValue('surname', (_c = person.surname) !== null && _c !== void 0 ? _c : '');
        }
    }, [person, setValue, isNewFamilyMember, profile]);
    useEffect(function () {
        return function () {
            dispatch(GeneralActions.setIsFamilyMemberMinor(false));
        };
    }, [dispatch]);
    var _k = useController({
        name: 'name',
        defaultValue: isNewFamilyMember ? profile.name : person === null || person === void 0 ? void 0 : person.name,
        control: control,
        rules: {
            required: {
                value: true,
                message: t('memberRegistry.inputNameRequiredError'),
            },
            pattern: {
                value: nameValidation,
                message: t('memberRegistry.inputNameValidationError'),
            },
            maxLength: {
                value: 30,
                message: t('memberRegistry.inputNameMaxLengthError'),
            },
            minLength: {
                value: 3,
                message: t('memberRegistry.inputNameMinLengthError'),
            },
            validate: function (value) {
                if (!(value === null || value === void 0 ? void 0 : value.trim())) {
                    return t('memberRegistry.inputNameRequiredError');
                }
                return true;
            },
        },
    }), field = _k.field, fieldState = _k.fieldState;
    var _l = useController({
        name: 'surname',
        defaultValue: isNewFamilyMember ? profile === null || profile === void 0 ? void 0 : profile.surname : person === null || person === void 0 ? void 0 : person.surname,
        control: control,
        rules: {
            maxLength: {
                value: 30,
                message: t('memberRegistry.inputSurnameMaxLengthError'),
            },
            minLength: {
                value: 3,
                message: t('memberRegistry.inputSurnameMinLengthError'),
            },
            validate: function (value) {
                if (!value || value.trim() === '') {
                    return true;
                }
                if (!nameValidation.test(value)) {
                    return t('memberRegistry.inputNameValidationError');
                }
                return true;
            },
        },
    }), surnameField = _l.field, surnameFieldState = _l.fieldState;
    var value = field.value, onChange = field.onChange;
    var initialValue = isNewFamilyMember ? profile === null || profile === void 0 ? void 0 : profile.name : person === null || person === void 0 ? void 0 : person.name;
    var hasReachedMinLength = useRef(((_c = initialValue === null || initialValue === void 0 ? void 0 : initialValue.trim().length) !== null && _c !== void 0 ? _c : 0) >= 3);
    if (((_d = value === null || value === void 0 ? void 0 : value.trim().length) !== null && _d !== void 0 ? _d : 0) >= 3) {
        hasReachedMinLength.current = true;
    }
    var handleChange = function (newValue) {
        onChange(newValue);
    };
    var handleSurnameChange = function (newValue) {
        surnameField.onChange(newValue);
    };
    var onCreatePersonAndUpdateCustomer = useMemo(function () {
        return handleSubmit(function (formData) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                updateProfile({
                    name: ((_a = formData.name) === null || _a === void 0 ? void 0 : _a.trim()) || '',
                    surname: ((_b = formData.surname) === null || _b === void 0 ? void 0 : _b.trim()) || undefined,
                }, onNext);
                return [2 /*return*/];
            });
        }); });
    }, [handleSubmit, updateProfile, onNext]);
    return {
        value: value,
        setValue: handleChange,
        errorMessage: hasReachedMinLength.current && ((_e = value === null || value === void 0 ? void 0 : value.trim().length) !== null && _e !== void 0 ? _e : 0) < 3
            ? (_f = fieldState.error) === null || _f === void 0 ? void 0 : _f.message
            : undefined,
        surnameValue: surnameField.value,
        setsurname: handleSurnameChange,
        surnameErrorMessage: (_g = surnameFieldState.error) === null || _g === void 0 ? void 0 : _g.message,
        onCreatePersonAndUpdateCustomer: onCreatePersonAndUpdateCustomer,
        isFamilyMember: isFamilyMember,
        isFormValid: !fieldState.error &&
            !fieldState.invalid &&
            !surnameFieldState.error &&
            !surnameFieldState.invalid,
        isB2BUser: isB2BUser,
    };
};
